import { useState, useEffect } from 'react';
import { sessionService } from '../../../services/sessionService';

export const useChatMessages = (currentSessionId) => {
  const [chatMessages, setChatMessages] = useState([]);

  useEffect(() => {
    if (currentSessionId) {
      loadMessages();
    }
  }, [currentSessionId]);

  const loadMessages = async () => {
    const { data: messages } = await sessionService?.getSessionMessages(currentSessionId);
    setChatMessages(messages || []);
  };

  const handleSendMessage = async (messageText) => {
    if (!currentSessionId || !messageText?.trim()) return;
    
    try {
      const { data, error } = await sessionService?.addSessionMessage(
        currentSessionId,
        messageText,
        'user'
      );
      
      if (error) {
        console.error('Failed to send message:', error);
        return;
      }
      
      setChatMessages(prev => [...prev, {
        id: data?.id,
        sender: 'user',
        text: messageText,
        timestamp: new Date()?.toISOString()
      }]);
    } catch (err) {
      console.error('Failed to send message:', err);
    }
  };

  return { chatMessages, handleSendMessage };
};